import { ReactComponent as PlusIcon } from 'assets/icons/plus-icon.svg';
import React, { useState } from 'react';

import { DescriptionWrap, DetailsButtonWrap, IconWrap, TitleWrap } from './DetailsButton.styles';

interface IProps {
  title: string;
  descerption: React.ReactNode;
}

const DetailsButton: React.FC<IProps> = ({ title, descerption }: any) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      {isOpen && (
        <DescriptionWrap>
          {descerption ? (
            descerption.map((desc: string, i: number) => <p key={i}>{desc}</p>)
          ) : (
            <>No description found</>
          )}
        </DescriptionWrap>
      )}
      <DetailsButtonWrap onClick={toggle}>
        <IconWrap isOpen={isOpen}>
          <PlusIcon />
        </IconWrap>
        <TitleWrap>{title}</TitleWrap>
      </DetailsButtonWrap>
    </>
  );
};

export default DetailsButton;
